export default [{
  path: '/statistics',
  meta: {
    keepAlive: true,
    pathName: 'statistics'
  },
  component: resolve => require(['../view/statistics/index'], resolve),
  children: [{
    path: 'supplier',
    meta: {
      keepAlive: true,
      pathName: 'supplier'
    },
    component: resolve => require(['../view/statistics/supplier'], resolve)
  }]
}]



// WEBPACK FOOTER //
// ./src/router/statistics.js